<div class="p-g signup-fee-collection-res">
    <div class="p-g-12 mobile-padding-0">
        <p-table [value]="members" [paginator]="true" [rows]="10" [loading]="loading" class="p-table-tecfolk-fix">
            <ng-template pTemplate="header">
                <tr>
                    <th>{{setLabel("memberShipNoLabel")}}</th>
                    <th>{{setLabel("nameLabel")}}</th>
                    <th>{{setLabel("joiningDateLabel")}}</th>
                    <th>{{setLabel("mobileLabel")}}</th>
                    <!-- <th>{{setLabel("trainerFeeLabel")}}</th> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-membercard>
                <tr>
                    <td>
                        <div class="mobile-label">{{setLabel("memberShipNoLabel")}}</div>
                        <div>{{ membercard.tagNumber }}</div>
                    </td>
                    <td>
                        <div class="mobile-label">{{setLabel("nameLabel")}}</div>
                        <div>{{ membercard.name }}</div>
                    </td>
                    <td>
                        <div class="mobile-label">{{setLabel("joiningDateLabel")}}</div>
                        <div>{{membercard.joiningDate | date: "dd/MM/yyyy"}}</div>
                    </td>
                    <td>
                        <div class="mobile-label">{{setLabel("mobileLabel")}}</div>
                        <div>{{ membercard.contactDetail.contact }}</div>
                    </td>
                    <!-- <td>
                        <div class="mobile-label">{{setLabel("trainerFeeLabel")}}</div>
                        <div>{{ membercard.customerstrainer.totalFees }}</div>
                    </td> -->
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div class="p-g-12">
        <div class="p-g-4"></div>
        <div class="p-g-4" style="text-align: center">
            <button class="p-button p-widget p-state-default
                p-corner-all collect-fee-btn" type="button">
                <span class="p-button-text p-c" (click)="feeInvoice()"><i class="fa fa-check"
                        aria-hidden="true"></i>&nbsp;&nbsp;{{setLabel("collectFeeLabel")}} <span style="
                        font-family: none;
                        font-size: small;
                        color: limegreen;"> (F2)</span> </span>
            </button>
        </div>
        <div class="p-g-4"></div>
    </div>
</div>